import { buildRegistrationAdmissionsAggregateListPath } from '../../generated/schooly-api-v1/api-paths';

export const getAdmissionAggregatePath = buildRegistrationAdmissionsAggregateListPath;
